/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ICusHeader containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum layout {
    standard = 'standard',
    logoOnlyCentered = 'logoOnlyCentered'
}

export interface ICusHeaderConfig extends Msdyn365.IModuleConfig {
    logoImage: Msdyn365.IImageData;
    logoLink?: ILogoLinkData;
    layout?: layout;
    enableRedirectOnCookie?: boolean;
    shouldRedirectToLocale?: boolean;
    deleteCookiesOnLocaleSwitch?: boolean;
    shouldLogOutInvalidLocaleUser?: boolean;
    isSignInPage?: boolean;
    enableNewsletterConsentSync?: boolean;
}

export interface ICusHeaderResources {
    headerAriaLabel: string;
    mobileHamburgerAriaLabel: string;
    mobileMenuTitle: string;
    mobileMenuCloseButtonLabel: string;
}

export interface ILogoLinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface ICusHeaderProps<T> extends Msdyn365.IModule<T> {
    resources: ICusHeaderResources;
    config: ICusHeaderConfig;
    slots: {
        menuBar: React.ReactNode[];
        search: React.ReactNode[];
        wishlistIcon: React.ReactNode[];
        accountIcon: React.ReactNode[];
        cartIcon: React.ReactNode[];
    };
}
